<template>
  <v-container>
    <TitleParagraphRow :value="value" />

    <v-row>
      <v-col>
        <v-table hover>
          <thead>
            <tr>
              <th></th>
              <th class="text-left" style="vertical-align: bottom">
                <h3 v-if="value.rows_heading" class="text-h5 my-3">
                  {{ value.rows_heading }}
                </h3>
              </th>

              <template v-if="value.columns && value.columns.length">
                <th
                  v-for="(column, i) in value.columns"
                  :key="i"
                  :style="TH_STYLE"
                >
                  <div class="text-center my-3" style="min-height: 90px">
                    <v-avatar
                      v-if="column.icon"
                      class="pa-1"
                      rounded="0"
                      size="90"
                    >
                      <v-img
                        :src="iconSrc(column.icon)"
                        alt="Badge for package to compare"
                      />
                    </v-avatar>
                  </div>

                  <h3 v-if="column.title" class="text-h5 my-3">
                    <StyledText :value="column.title" />
                  </h3>
                  <div v-if="column.paragraph" class="my-3">
                    <StyledText :value="column.paragraph" />
                  </div>
                </th>
              </template>

              <th :style="TH_STYLE_LAST"></th>
            </tr>
          </thead>

          <tbody v-if="value.rows && value.rows.length">
            <tr v-for="(row, j) in value.rows" :key="`row-${j}`">
              <td :class="row.section ? 'bg-surface-light' : ''"></td>
              <td
                :class="
                  row.section
                    ? 'bg-surface-light text-subtitle-1 font-weight-bold py-2'
                    : 'text-body-1 py-2'
                "
              >
                {{ row.title }}
              </td>

              <template v-if="value.columns && value.columns.length">
                <td
                  v-for="(column, k) in value.columns"
                  :key="`row-${j}-col-${k}`"
                  :class="row.section ? 'bg-surface-light' : 'text-center'"
                  :style="TD_STYLE"
                >
                  <v-icon
                    v-if="
                      row.cells &&
                      row.cells[k] &&
                      row.cells[k].icon &&
                      CELL_ICONS[row.cells[k].icon]
                    "
                    :icon="CELL_ICONS[row.cells[k].icon]"
                  />
                </td>
              </template>

              <td
                :class="row.section ? 'bg-surface-light' : ''"
                :style="TH_STYLE_LAST"
              ></td>
            </tr>
          </tbody>
        </v-table>
      </v-col>
    </v-row>

    <v-row v-if="value.footnote_paragraph">
      <v-col>
        <p class="text-body-1">
          <StyledText :value="value.footnote_paragraph" />
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { createImgSrc } from '#root/lib/img'
import { mdiCheckCircle } from '@mdi/js'

const CELL_ICONS = {
  check: mdiCheckCircle
}
const TD_STYLE = {
  borderLeft: 'thin solid rgba(0, 0, 0, 0.12)',
  width: '182px'
}
const TH_STYLE = {
  borderLeft: 'thin solid rgba(0, 0, 0, 0.12)',
  verticalAlign: 'top',
  width: '182px'
}
const TH_STYLE_LAST = {
  borderLeft: 'thin solid rgba(0, 0, 0, 0.12)'
}

defineProps({
  value: {
    required: true,
    type: Object
  }
})

const iconSrc = createImgSrc()
</script>
